module.exports = __webpack_public_path__ + "img/bird-house_white.7ee7510f.svg";